import { useMutation, useQueryClient } from '@tanstack/react-query';
import { branchKey, keys } from '@/lib/queryKeys';
import { createStockAdjustment } from './api';
import type { CreateStockAdjustmentInput } from './types';

export function useCreateStockAdjustment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateStockAdjustmentInput) => createStockAdjustment(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.pharmacy.inventory() });
      // G15: over the approval limit the request lands in the waiting list instead.
      queryClient.invalidateQueries({ queryKey: branchKey('pharmacy', 'adjustment-requests') });
    },
  });
}
